import React from 'react'

import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'
import { HasilPenilaianKinerja } from 'app/KinerjaPage/pages/PelaksanaanV2/HasilPenilaianKinerja'
import { HasilPenilaianKinerjaV2 } from 'app/KinerjaPage/pages/PelaksanaanV2/HasilPenilaianKinerjaV2'
import { useIsPrior2025 } from 'app/KinerjaShared/hooks/useIsPrior2025'

import type { HasilPenilaianKinerjaProps } from 'app/KinerjaPage/pages/PelaksanaanV2/HasilPenilaianKinerja'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'

type PageParams = Pick<HasilPenilaianKinerjaProps, 'isAnnual'>

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false
    const isAnnual = !!context?.query?.annual

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return {
      props: {
        isAnnual,
      },
    }
  },
})

const Page = ({ isAnnual }: PageProps & PageParams) => {
  const isPriorTo2025 = useIsPrior2025()

  if (isPriorTo2025) {
    return (
      <PageGuardPelaksanaanDate>
        <HasilPenilaianKinerja isAnnual={isAnnual} />
      </PageGuardPelaksanaanDate>
    )
  }
  return (
    <PageGuardPelaksanaanDate>
      <HasilPenilaianKinerjaV2 />
    </PageGuardPelaksanaanDate>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  printablePage: true,
}

export default Page
